import { api, ApiRequestConfig } from 'api';
import { State, Store } from 'store/types';
import { FETCH_PRODUCTS } from './products-constants';
import { Product } from './products-types';

/**
 * Загрузка информации о замерах
 * @param {string[]} productIdList
 * @param {string} regionCode
 * @param {ApiRequestConfig} apiRequestConfig
 * @returns {Promise<Product>}
 */
export const getProducts = (
  productIdList: string[],
  regionCode: string,
  apiRequestConfig: ApiRequestConfig
) =>
  api.get<Product>(
    'offer-getting',
    {
      products: productIdList.join(),
      masks: '"price", "mediaMainPhoto", "displayedName"',
      regions: regionCode,
    },
    apiRequestConfig
  );

/**
 * Экшен загрузки измерения
 * @param {Store}    store
 * @param {string[]} productIdList
 * @returns {Promise<State>}
 */
export const loadProductsAction = (store: Store, productIdList: string[]) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(FETCH_PRODUCTS.init, { productIdList });

    const unsub = store.on('@dispatch', state => {
      if (state.products.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
